import { ScheduleRuleName } from './api/usePairMapper';

export const SCHEDULE_RULE_LABELS: Record<ScheduleRuleName, string> = {
  polymarket: 'Hourly Polymarket',
  kalshi: 'Hourly Kalshi',
  crypto: 'Crypto',
  dailyTemp: 'Daily temp',
  live: 'Live',
};

export const SCHEDULE_RULE_ORDER: ScheduleRuleName[] = [
  'polymarket',
  'kalshi',
  'crypto',
  'dailyTemp',
  'live',
];
